/** Backend Flashcard.CardType values. */
export enum FlashcardType {
  Text = 1,
  Image = 2,
  VideoOnly = 3,
  AudioRecord = 4,
  ShortTalk = 5,
  AudioConversation = 6,
  Pronunciation = 7,
  Adaptive = 8,
}
